import React, { ComponentProps } from "react";

export default function QuestionmarkIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M5.28053 5.02667C4.7472 4.8 4.52053 4.14 4.84053 3.66C5.4872 2.7 6.5672 2 7.99387 2C9.56053 2 10.6339 2.71333 11.1805 3.60667C11.6472 4.37333 11.9205 5.80667 11.2005 6.87333C10.4005 8.05333 9.63387 8.41333 9.22053 9.17333C9.12053 9.35333 9.06053 9.5 9.02053 9.8C8.96053 10.2867 8.56053 10.6667 8.0672 10.6667C7.4872 10.6667 7.01387 10.1667 7.08053 9.58667C7.12053 9.24667 7.20053 8.89333 7.3872 8.56C7.90053 7.63333 8.8872 7.08667 9.46053 6.26667C10.0672 5.40667 9.7272 3.8 8.0072 3.8C7.2272 3.8 6.72053 4.20667 6.4072 4.69333C6.17387 5.07333 5.6872 5.19333 5.28053 5.02667ZM9.33387 13.3333C9.33387 14.0667 8.73387 14.6667 8.00053 14.6667C7.2672 14.6667 6.6672 14.0667 6.6672 13.3333C6.6672 12.6 7.2672 12 8.00053 12C8.73387 12 9.33387 12.6 9.33387 13.3333Z"
        fill="#434343"
      />
    </svg>
  );
}
